import React from 'react';
import queryString from 'query-string';
import {connect} from 'react-redux';
import {DETAILS_TITLE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {Loader, Header} from 'semantic-ui-react';
import {Container, Grid} from 'semantic-ui-react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import WorkloadFilter from './workloadDashboard/workloadFilter';
import WorkloadTable from './workloadDashboard/workloadTable';
import AnalyticsCard from './workloadDashboard/analyticsCard';
import {Alert} from 'componentLibrary';
import camundaTaskVars from 'app-ui-componentlibrary/dist/go/components/common/workflow/camundaTaskVars';
import _ from 'lodash';
import {getUserEntitiesForEntityType} from 'common/utils';
import {Redirect} from 'react-router-dom';
import {ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import REST from 'go/requests/rest';

const LOCAL_STORAGE_KEY = 'workloadDashboard';

let CLEAR_FILTERS = {
  assignee: '',
  sortOrder: 'desc',
  sortBy: 'created',
};

export class WorkloadDashboard extends React.Component {
  constructor(props) {
    super(props);

    const filtersFromStorage = this.getStoredFilters();

    const initialFilters =
      !_.isEmpty(filtersFromStorage) && filtersFromStorage !== 'undefined'
        ? filtersFromStorage
        : CLEAR_FILTERS;

    this.state = {
      loading: true,
      filterSet: 0,
      error: false,
      maxResults: 25,
      firstResult: 0,
      filters: initialFilters,
      filtersAsEntered: initialFilters,
      results: [],
      assigneeList: [],
      taskNameList: [],
      userObjs: [],
      fundingOpps: [],
    };
  }

  componentDidMount() {
    document.title = DETAILS_TITLE;
    this.fetchMoreData();
    this.fetchAssignedTo();
    this.fetchTaskName();
    const userPrograms = getUserEntitiesForEntityType(
      this.props.permissions,
      ENTITY_MAP.PROGRAM.code
    );
    _.each(userPrograms, this.getFundingOpportunitiesForProgram);
  }

  getStoredFilters = () => {
    const {id} = this.props;
    const filter = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {};
    if (filter) {
      if (filter.userId !== id) {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({}));
      } else return filter;
    }
    return {};
  };

  getFundingOpportunitiesForProgram = (programId) => {
    REST.fundingOpportunity
      .getFundingOpportunitiesForProgram(this.props.token, programId)
      .then((response) => response.json())
      .then((resJson) => {
        const parsedJson = JSON.parse(resJson.payload);
        this.setState(
          {
            fundingOpps: this.state.fundingOpps.concat(parsedJson.fundingOpportunities),
          },
          () => {
            const item = this.getStoredFilters();

            let objectOfFilters = {sortOrder: 'desc', sortBy: 'created', assignee: ''};
            _.each(_.keys(item), (i) => {
              if (_.get(item, i)) {
                if (i === 'followUpRequired') {
                  if (_.get(item, i) === 'true') {
                    objectOfFilters[i] = true;
                  } else if (_.get(item, i) === 'false') {
                    objectOfFilters[i] = false;
                  } else {
                    objectOfFilters[i] = _.get(item, i);
                  }
                } else {
                  objectOfFilters[i] = _.get(item, i);
                }
              }
            });
            this.onFilterChange(objectOfFilters);
          }
        );
      })
      .catch((error) => {
        console.error('error');
      });
  };

  fetchAssignedTo() {
    REST.workflow
      .getAssignedTo(this.props.token)
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        this.setState(
          {
            assigneeList: resJson,
          },
          () => {
            const notNull = _.filter(resJson, (userId) => userId !== null);
            this.getRoles(notNull);
          }
        );
      })
      .catch((error) => {
        console.error('error');
      });
  }

  fetchTaskName() {
    REST.workflow
      .getAvailableTaskNames(this.props.token)
      .then(REST.handler.handleResponse)
      .then((resJson) => {
        this.setState({
          taskNameList: resJson,
        });
      })
      .catch((error) => {
        console.error('error');
      });
  }

  getRoles = (userListinput) => {
    const fetchBody = {
      userId: [],
    };
    let count = 0;
    for (var user in userListinput) {
      if (count == 0) {
        fetchBody.userId.push(userListinput[user]);
        count++;
      } else {
        fetchBody.userId.push(userListinput[user]);
      }
    }
    if (fetchBody.userId.length !== 0) {
      REST.user
        .getProfilesForUsers(this.props.token, fetchBody)
        .then(REST.handler.handleResponse)
        .then((data) => {
          this.setState({
            userObjs: data,
          });
        })
        .catch((error) => {
          console.error('error');
        });
    }
  };

  onFilterChange = (filters) => {
    const {id} = this.props;
    filters = filters || {sortOrder: 'desc', sortBy: 'created'};
    filters.userId = id;
    const transformedFilters = this.transformFilters(filters);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(filters));

    this.setState(
      {
        firstResult: 0,
        filtersAsEntered: filters,
        filters: transformedFilters,
        loading: true,
        filterSet: this.state.filterSet + 1,
        results: [],
      },
      this.fetchMoreData
    );
  };

  transformFilters = (filters) => {
    const transformedFilters = {};
    _.forEach(filters, (value, name) => {
      if (name === 'fundingOpportunityNumber') {
        value = _.get(
          _.find(this.state.fundingOpps, (fo) => fo.fundingOpportunityName === value),
          'fundingOpportunityNr',
          value
        );
      } else if (name !== 'userId') {
        transformedFilters[name] = value;
      }
    });
    return transformedFilters;
  };

  createFetchBody = () => {
    const {filters} = this.state;
    const parsed = queryString.parse(this.props.location.search);

    let fetchBody = {};
    if (filters['assignee'] == 'unassigned' || filters['assignee'] == null) {
      filters['assignee'] = null;
      fetchBody = {
        ...parsed,
        candidateGroups: this.props.permissions,
        processVariables: [],
        sorting: [],
      };
    } else {
      fetchBody = {
        ...parsed,
        includeAssignedTasks: true,
        candidateGroups: this.props.permissions,
        processVariables: [],
        sorting: [],
      };
    }

    // Handle sorting
    if (filters['sortBy']) {
      // Check if we're sorting by a process var...
      if (camundaTaskVars.indexOf(filters['sortBy']) < 0) {
        fetchBody.sorting.push({
          sortBy: 'processVariable',
          sortOrder: filters['sortOrder'],
          parameters: {
            variable: filters['sortBy'],
            type: 'string',
          },
        });
      } else {
        if (filters['sortBy'] == 'created' && filters['sortOrder'] == 'asc') {
          fetchBody.sorting.push({
            sortOrder: 'desc',
            sortBy: 'created',
          });
        } else if (filters['sortBy'] == 'created' && filters['sortOrder'] == 'desc') {
          fetchBody.sorting.push({
            sortOrder: 'asc',
            sortBy: 'created',
          });
        } else {
          fetchBody.sorting.push({
            sortBy: filters['sortBy'],
            sortOrder: filters['sortOrder'],
          });
        }
      }
    }

    //Always add a sort by creation time
    fetchBody.sorting.push({});

    // Handle search filters...
    _.forEach(_.keys(filters), (key) => {
      if (key !== 'sortBy' && key !== 'sortOrder' && filters[key]) {
        if (camundaTaskVars.indexOf(key) < 0) {
          const filterValue = filters[key];
          if (key === 'grantId' || key === 'subGrantId') {
            fetchBody.processVariables.push({
              name: key,
              value: `%${filterValue}%`,
              operator: 'like',
            });
          } else {
            fetchBody.processVariables.push({
              name: key,
              value: filterValue,
              operator: 'eq',
            });
          }
        } else {
          fetchBody[key] = filters[key];
        }
      }
    });
    return fetchBody;
  };
  // Required to calculate the assigned count when filters are selected
  createFetchBodyAssigned = () => {
    const {filters} = this.state;
    const parsed = queryString.parse(this.props.location.search);
    const fetchBody = {
      ...parsed,
      candidateGroups: this.props.permissions,
      assigned: true,
      includeAssignedTasks: true,
      processVariables: [],
      sorting: [],
    };

    // Handle sorting
    if (filters['sortBy']) {
      // Check if we're sorting by a process var...
      if (camundaTaskVars.indexOf(filters['sortBy']) < 0) {
        fetchBody.sorting.push({
          sortBy: 'processVariable',
          sortOrder: filters['sortOrder'],
          parameters: {
            variable: filters['sortBy'],
            type: 'string',
          },
        });
      } else {
        if (filters['sortBy'] == 'created' && filters['sortOrder'] == 'asc') {
          fetchBody.sorting.push({
            sortOrder: 'desc',
            sortBy: 'created',
          });
        } else if (filters['sortBy'] == 'created' && filters['sortOrder'] == 'desc') {
          fetchBody.sorting.push({
            sortOrder: 'asc',
            sortBy: 'created',
          });
        } else {
          fetchBody.sorting.push({
            sortBy: filters['sortBy'],
            sortOrder: filters['sortOrder'],
          });
        }
      }
    }

    //Always add a sort by creation time
    fetchBody.sorting.push({});

    // Handle search filters...
    _.forEach(_.keys(filters), (key) => {
      if (key !== 'sortBy' && key !== 'sortOrder' && filters[key]) {
        if (camundaTaskVars.indexOf(key) < 0) {
          fetchBody.processVariables.push({
            name: key,
            value: filters[key],
            operator: 'eq',
          });
        } else {
          fetchBody[key] = filters[key];
        }
      }
    });
    return fetchBody;
  };

  //required to calculate the unassigned count when filters are selected
  createFetchBodyunAssigned = () => {
    const {filters} = this.state;
    const parsed = queryString.parse(this.props.location.search);
    const fetchBody = {
      ...parsed,
      candidateGroups: this.props.permissions,
      unassigned: true,
      includeAssignedTasks: true,
      processVariables: [],
      sorting: [],
    };

    // Handle sorting
    if (filters['sortBy']) {
      // Check if we're sorting by a process var...
      if (camundaTaskVars.indexOf(filters['sortBy']) < 0) {
        fetchBody.sorting.push({
          sortBy: 'processVariable',
          sortOrder: filters['sortOrder'],
          parameters: {
            variable: filters['sortBy'],
            type: 'string',
          },
        });
      } else {
        if (filters['sortBy'] == 'created' && filters['sortOrder'] == 'asc') {
          fetchBody.sorting.push({
            sortBy: 'created',
            sortOrder: 'desc',
          });
        } else if (filters['sortBy'] == 'created' && filters['sortOrder'] == 'desc') {
          fetchBody.sorting.push({
            sortBy: 'created',
            sortOrder: 'asc',
          });
        } else {
          fetchBody.sorting.push({
            sortBy: filters['sortBy'],
            sortOrder: filters['sortOrder'],
          });
        }
      }
    }
    //Always add a sort by creation time
    fetchBody.sorting.push({});

    // Handle search filters...
    _.forEach(_.keys(filters), (key) => {
      if (key !== 'sortBy' && key !== 'sortOrder' && filters[key]) {
        if (camundaTaskVars.indexOf(key) < 0) {
          fetchBody.processVariables.push({
            name: key,
            value: filters[key],
            operator: 'eq',
          });
        } else {
          fetchBody[key] = filters[key];
        }
      }
    });
    return fetchBody;
  };

  fetchMoreData = _.debounce(
    () => {
      const {firstResult, maxResults} = this.state;

      var fetchBody = this.createFetchBody();
      const currentFilterSet = this.state.filterSet;

      REST.workflow
        .getTasksWithVariables(
          this.props.token,
          fetchBody,
          [
            'awardNumber',
            'followUpRequired',
            'organizationId',
            'grantId',
            'subGrantId',
            'region',
            'fundingOpportunityNumber',
            'organizationName',
            'fundingOpportunityName',
          ],
          maxResults,
          firstResult
        )
        .then(REST.handler.handleResponse)
        .then((results) => {
          if (currentFilterSet === this.state.filterSet) {
            const currentResults = this.state.results ? this.state.results : [];
            this.setState({
              results: currentResults.concat(results),
              loading: false,
              firstResult: this.state.firstResult + results.length,
              hasMore: results.length === this.state.maxResults,
            });
          }
        })
        .catch((error) => {
          console.error('error');
        });
    },
    250,
    {loading: true}
  );

  renderTasks = (results, loading) => {
    const workloadHMAToggle = _.includes(this.props.toggles, 'workloadHMA');
    const sortReorder = _.includes(this.props.toggles, 'disasterSiteNav');
    return (
      <Main>
        <Container fluid>
          <Header as="h1" title="FEMAGO Current Workload">
            Current Workload
          </Header>

          <Grid doubling stackable reversed="mobile" padded="vertically">
            {loading && (
              <Grid.Column width={12}>
                <Loader inline="centered" active>
                  Loading...
                </Loader>
              </Grid.Column>
            )}
            {!loading && (
              <>
                {sortReorder && (
                  <Grid.Column width={4}>
                    <WorkloadFilter
                      assigneeList={this.state.assigneeList}
                      filters={this.state.filters}
                      onFilterChange={this.onFilterChange}
                      taskNameList={this.state.taskNameList}
                      userObjs={this.state.userObjs}
                      fundingOpps={this.state.fundingOpps}
                      filtersAsEntered={this.state.filtersAsEntered}
                      workloadHMAToggle={workloadHMAToggle}
                    />
                  </Grid.Column>
                )}
                <Grid.Column width={12}>
                  <AnalyticsCard
                    filters={this.state.filters}
                    results={results}
                    createFetchBody={this.createFetchBody}
                    createFetchBodyAssigned={this.createFetchBodyAssigned}
                    createFetchBodyunAssigned={this.createFetchBodyunAssigned}
                    userObjs={this.state.userObjs}
                    fundingOpps={this.state.fundingOpps}
                    filtersAsEntered={this.state.filtersAsEntered}
                  />

                  {results && results.length > 0 && (
                    <WorkloadTable
                      results={results}
                      hasMore={this.state.hasMore}
                      fetchMoreData={this.fetchMoreData}
                      filters={this.state.filters}
                      userObjs={this.state.userObjs}
                      fundingOpps={this.state.fundingOpps}
                      filtersAsEntered={this.state.filtersAsEntered}
                    />
                  )}
                  {(!results || results.length === 0) && (
                    <Alert header="No tasks available" type="info">
                      There were no tasks found that match your filter criteria.
                    </Alert>
                  )}
                </Grid.Column>
              </>
            )}
            {!sortReorder && (
              <Grid.Column width={4}>
                <WorkloadFilter
                  assigneeList={this.state.assigneeList}
                  filters={this.state.filters}
                  onFilterChange={this.onFilterChange}
                  taskNameList={this.state.taskNameList}
                  userObjs={this.state.userObjs}
                  fundingOpps={this.state.fundingOpps}
                  filtersAsEntered={this.state.filtersAsEntered}
                  workloadHMAToggle={workloadHMAToggle}
                />
              </Grid.Column>
            )}
          </Grid>
        </Container>
      </Main>
    );
  };

  render() {
    const {results, taskId, loading} = this.state;
    if (taskId) {
      return <Redirect to={`/tasks/${taskId}`} push />;
    } else {
      return this.renderTasks(results, loading);
    }
  }
}

export const mapStateToProps = (state) => {
  return {
    id: state.auth.userId,
    token: state.auth.token,
    permissions: state.auth.permissions,
    toggles: _.get(state.toggles, 'toggles'),
  };
};

export default connect(mapStateToProps)(WorkloadDashboard);
